<template>
  <div class="hs-login">
    <div class="hs-login-bg"></div>
    <div class="hs-login-container">
      <div class="hs-login-card">
        <div class="hs-login-header">
<!--          <div class="hs-login-logo">-->
<!--            <img src="../assets/logo.png" alt="logo" />-->
<!--          </div>-->
          <h1 class="hs-login-title">欣环助循</h1>
          <p class="hs-login-desc">运营管理系统</p>
        </div>
        <div class="hs-login-form">
          <div class="hs-login-row">
            <Input
              type="text"
              v-model.tirm="formInline.username"
              @keyup.enter.native="handleSubmit"
              placeholder="请输入登录账号"
              prefix="md-person"
              size="large"
            />
          </div>
          <div class="hs-login-row">
            <Input
              type="password"
              v-model.tirm="formInline.password"
              @keyup.enter.native="handleSubmit"
              placeholder="请输入密码"
              prefix="md-lock"
              size="large"
            />
          </div>
          <div class="hs-login-row">
            <template v-if="isPc">
              <hs-verification-pc @change="verificationChange"></hs-verification-pc>
            </template>
            <template v-else>
              <hs-verification-app @change="verificationChange"></hs-verification-app>
            </template>
          </div>
          <div class="hs-login-row">
            <Button
              type="primary"
              size="large"
              :style="{width:'100%'}"
              @click="handleSubmit"
              :loading="btnLoading"
              class="hs-login-btn"
            >登 录</Button>
          </div>
        </div>
        <div class="hs-login-footer">
          <span>版权所有 &copy; 欣环助循</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import hsVerificationPc from '@/components/hs-verification-pc';
import hsVerificationApp from '@/components/hs-verification-app';

export default {
  name: "login",
  data() {
    return {
      btnLoading: false,
      formInline: {
        username: '',
        password: '',
        verification: false
      },
      isPc: true,
    }
  },
  mounted() {
    this.judge();
  },
  methods: {
    handleSubmit() {
      if (!this.formInline.username) {
        this.$Message.error('请输入用户名');
        return false;
      } else if (!/^[0-9a-zA-Z]+$/.test(this.formInline.username)) {
        this.$Message.error('用户名格式不正确');
        return false;
      } else if (!this.formInline.password) {
        this.$Message.error('请输入密码');
        return false;
      } else if (!this.formInline.verification) {
        this.$Message.error('请滑动验证码');
        return false;
      } else {
        this.loginCheck();
      }
    },
    loginCheck() {
      this.btnLoading = true;
      this.axios.post('/adminLogin/loginCheck', this.formInline).then(res => {
        this.btnLoading = false;
        if (res.status == 200) {
          sessionStorage.setItem('J-TOKEN', JSON.stringify(res.data));
          this.$router.push({
            path: '/index/charts',
          })
        }
        if (res.status == 201) {
          this.$Message.error(res.msg);
        }
      })
    },
    judge() {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.isPc = false;
      } else {
        this.isPc = true;
      }
      window.addEventListener('resize', () => {
        if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
          this.isPc = false;
        } else {
          this.isPc = true;
        }
      })
    },
    verificationChange(e) {
      this.formInline.verification = e;
    }
  },
  components: {
    hsVerificationPc,
    hsVerificationApp
  }
}
</script>

<style scoped lang="less">
.hs-login {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  .hs-login-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url("../assets/login_bg.png") no-repeat center center;
    background-size: cover;
  }

  .hs-login-container {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 20px;
  }

  .hs-login-card {
    width: 420px;
    padding: 40px 36px 24px;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 16px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(10px);
    animation: cardFadeIn 0.6s ease-out;
  }

  @keyframes cardFadeIn {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .hs-login-header {
    text-align: center;
    margin-bottom: 32px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .hs-login-logo {
      width: 72px;
      height: 72px;
      margin-bottom: 12px;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .hs-login-title {
      font-size: 26px;
      font-weight: 700;
      color: #1a1a2e;
      margin: 0;
      letter-spacing: 4px;
    }

    .hs-login-desc {
      font-size: 14px;
      color: #909399;
      margin: 6px 0 0;
      letter-spacing: 2px;
    }
  }

  .hs-login-form {
    .hs-login-row {
      margin-bottom: 20px;
    }
  }

  .hs-login-btn {
    height: 44px;
    font-size: 16px;
    letter-spacing: 6px;
    border-radius: 8px;
    background: linear-gradient(135deg, #3b82f6, #2563eb);
    border: none;
    transition: all 0.3s ease;
    box-shadow: 0 4px 14px rgba(59, 130, 246, 0.4);

    &:hover {
      background: linear-gradient(135deg, #60a5fa, #3b82f6);
      box-shadow: 0 6px 20px rgba(59, 130, 246, 0.5);
      transform: translateY(-1px);
    }

    &:active {
      transform: translateY(0);
    }
  }

  .hs-login-footer {
    text-align: center;
    margin-top: 24px;
    padding-top: 20px;
    border-top: 1px solid #f0f0f0;

    span {
      font-size: 12px;
      color: #c0c4cc;
    }
  }
}
</style>
